import {FC, useState} from 'react'
import {CDRModalRecord} from '../../components/CDRModalRecord'
import {useParams} from 'react-router-dom'
import {appsAPI} from '../../../../services/AppsService'
import {DataCDR} from '../../core/_models'

type Props = {
  data?: DataCDR
}

const CDRRecord: FC<Props> = ({data}) => {
  const {appId} = useParams()
  const [show, setShow] = useState(false)
  const {data: app} = appsAPI.useFetchAppByIdQuery(appId!)

  const handleClose = () => setShow(false)

  return (
    <div className='d-flex align-items-center'>
      {data && data.talk_duration > 0 && (
        <>
          <i
            className='bi bi-play-circle fs-1 text-primary cursor-pointer'
            onClick={() => {
              setShow(true)
            }}
          />
          <CDRModalRecord
            recordUrl={`${app?.settings.asterisk.record_url}${data.record_url}`}
            show={show}
            handleClose={handleClose}
          />
        </>
      )}
    </div>
  )
}

export {CDRRecord}
